
import { call, takeEvery, put, delay } from 'redux-saga/effects';
import { message } from 'antd';
import paymentTransaction from '../Actions/paymentTransaction';
import login from "../Actions/login";
import license from '../Actions/license';
import { savePreUserPaymentTransactionRequest, preUserApplyPaymentTransactionRequest, saveUserPaymentTransactionRequest, 
        userApplyPaymentTransactionRequest, createPaymentTokenRequest, stampPackageRequest } from '../Api/PaymentTransaction';
import { getConfigTransactionRequest } from '../Api/Utils';
import { startLoading, stopLoading } from '../LoadingHelper';
import { setSessionData } from '../Helpers/loginHelper';
import auth from '../auth';
import { getToken } from '../helpers';
import { isNullOrEmpty } from '../Helpers/validationsHelper';
import ErrorManager from '../Helpers/ErrorManager';
import { CATEGORY_GA, eventGA } from  '../Helpers/GoogleAnalytics';
const { types, actions } = paymentTransaction;
const { setConfigTransaction } = actions;
const { updateLoginStatus } = login.actions
const { getLicenseData, getLicensesHistorical, getBalanceData } = license.actions;
const { showStampInvoiceModal } = paymentTransaction.actions;

export function* getConfigTransaction({ data }) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(getConfigTransactionRequest);
        if (response && response.status === 'success') {
            yield put(setConfigTransaction(response.data));
        } else {
            message.error(response.messageDetail, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* savePreUserNewTransaction({ data }) {
    const loadingId = yield call(startLoading);
    try {
        let { packageData, amount, info, form , config } = data;
        let { callback, payments } = getUrlsValues(config);
        let callbackUrl = parseCallbackUrl({ url: callback.value, isUser: false });
        let requestBody = {
            IdDealer: info.idPreUsuario,
            IdUser: info.idPreUsuario,
            NombrePaquete: packageData.packageId,
            Paquete: JSON.stringify(packageData),
            ClienteNombre: form.nombreCliente,
            ClienteApellido: form.apellidoCliente,
            ClienteTelefono: form.telefono,
            ClienteCorreo: info.email,
            IdTipoServicio: 1,
            Callback: callbackUrl,
            Estatus: -1,
            DescripcionEstatus: '',
            Total: amount,
        };
        
        const response = yield call(savePreUserPaymentTransactionRequest, requestBody);
        if (response && response.status === 'success') {
            let swUser = {
                Email: requestBody.ClienteCorreo,
                IdUser: requestBody.IdUser,
                IdDealer: requestBody.IdDealer,
            };
            let token = yield call(getPaymentToken, swUser);
            if (amount === '0') { //free packages
                let redirectValues = { url: callback.value, idTransaction: response.data, token };                
                successResponseRedirectFreePackge(redirectValues);
            } else {
                let redirectValues = { url: payments.value, idTransaction: response.data, token };
                successResponseRedirect(redirectValues);
            }
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* preUserApplyPaymentTransaction({data}) {
    const loadingId = yield call(startLoading, 'licenseLoading');
    try {
        const { transactionId, history, packageToBuy } = data;
        const response = yield call(preUserApplyPaymentTransactionRequest, transactionId, packageToBuy);
        if (response && response.status === 'success') {
            auth.clearStorages();
            eventGA(CATEGORY_GA.sales.purchaseWasMade);
            yield put(updateLoginStatus({isLogged: true}));
            setSessionData({response, message, auth, history });
            yield put(getLicenseData());
        } else if(response.status === 'error' && response.message === 'Usuario ya existe.') {
            window.location.href = '/';
        } else {
            message.error(response.message, 5); 
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* stampPackageInvoice({data}) {
    const loadingId = yield call(startLoading, 'licenseLoading');
    try {
    const response = yield call(stampPackageRequest, data);
    if(response.status === 'success') {
        message.success('Factura timbrada correctamente', 5);
        yield put(showStampInvoiceModal(false));
    } else
        message.error(response.message, 5);
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
    
}

export function* saveUserNewTransaction({ data }) {
    const loadingId = yield call(startLoading, 'licenseLoading');
    try {
        let { packageData, amount, config, info } = data;
        let { callback, payments } = getUrlsValues(config);
        let callbackUrl = parseCallbackUrl({ url: callback.value, isUser: true });
        
        let requestBody = {
            NombrePaquete: packageData.name,
            Paquete: JSON.stringify(packageData),
            Callback: callbackUrl,
            Total: amount,
        };

        const response = yield call(saveUserPaymentTransactionRequest, requestBody);
        if (response && response.status === 'success') {
            let swUser = {
                Email: info.email,
                IdUser: info.idUsuario,
                IdDealer: info.idCliente,
            };
            let token = yield call(getPaymentToken, swUser);
            let redirectValues = { url: payments.value, idTransaction: response.data, token };
            successResponseRedirect(redirectValues);
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* applyUserPaymentTransaction({data}) {
    const loadingId = yield call(startLoading);
    try {
        const { transactionId, packageToBuy, history } = data;
        const response = yield call(userApplyPaymentTransactionRequest, transactionId, packageToBuy);
        if (response && response.status === 'success') {
            if(!isNullOrEmpty(getToken())) {
                yield put(getLicenseData());
                yield put(getLicensesHistorical());
                yield put(getBalanceData());
                yield put(showStampInvoiceModal(true));
                history.push('/license');
            } else {
                message.error("Favor de iniciar sesión nuevamente", 5);
                yield delay(5000); 
                window.location.href = '/';
            }
        } else if(response.status === 'error' && response.message === 'Usuario ya existe.') {
            window.location.href = '/';
        } else {
            message.error(response.message, 5); 
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

const parseCallbackUrl = (values) => {
    let { url, isUser } = values;
    let result = url.replace('{{isUser}}', isUser);
    return result;
}

const successResponseRedirect = ({url, idTransaction, token}) => {
    message.success('Solicitud realizada correctamente', 5);    
    url = url.replace('{{token}}', token)
            .replace('{{idTransaction}}', idTransaction);
    window.location.href = url;
}

const successResponseRedirectFreePackge = ({url, idTransaction}) => {
    message.success('Solicitud realizada correctamente', 5);    
    url = url.replace('{{idTransaction}}',idTransaction).replace('{{isUser}}', false);
    window.location.href = url;
}

const getUrlsValues = config => {
    if (!config) {
        ErrorManager.throwError('No existe una configuración correcta para completar el proceso de pago');
    }

    let callback = config.find(item => item.key === 'callbackUrl');
    let payments = config.find(item => item.key === 'paymentsUrl');
    if (!callback || !payments) {
        ErrorManager.throwError('No se tiene una url de retorno o url de pago correcta, no se puede realizar el proceso de pago');
    }

    return { callback, payments };
}

function* getPaymentToken(swUser) {
    const response = yield call(createPaymentTokenRequest, swUser);
    if (response && response.status === 'success' && response.data) {
        return response.data.access_token;
    } else {
        ErrorManager.throwError(response.message);
    }
}


export function* paymentTransactionSaga() {
    yield takeEvery(types.GET_CONFIG_TRANSACTION, getConfigTransaction);
    yield takeEvery(types.SAVE_NEW_TRANSACTION, savePreUserNewTransaction);
    yield takeEvery(types.APPLY_PAYMENT_TRANSACTION, preUserApplyPaymentTransaction);
    yield takeEvery(types.SAVE_USER_NEW_TRANSACTION, saveUserNewTransaction);
    yield takeEvery(types.APPLY_USER_PAYMENT_TRANSACTION, applyUserPaymentTransaction);
    yield takeEvery(types.STAMP_PACKAGE_INVOICE, stampPackageInvoice);
};